module.exports = __webpack_public_path__ + "static/bee-team-7a1108f0344a0636ea6e19fae09b5d5d.jpg";